<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">
            {{ $t("tiktok.settings.webhooks_delete_title") }}
            <div class="number-block">
                <img class="icon" :src="tiktokIcon"/>
                <span>{{ info?.username }}</span>
            </div>
        </h3>

        <div class="content">
            <p class="confirm">{{ $t("dialog.webhooks.delete_confirm_text") }}</p>

            <div class="action_container">
                <ButtonLoading
                    :loading="button.loading"
                    :disabled="button.disabled"
                    @click="deleteWebhooks"
                >
                    {{ $t("common.delete") }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>



<script setup>
// core
import {ref, computed, getCurrentInstance} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore();
const tiktokIcon = require("@/assets/icons/tiktok.svg").default;
const {proxy} = getCurrentInstance();
const {t: $t} = useI18n();

const button = ref({
    loading: false,
    disabled: false,
});

const dialogParams = computed(() => store.state.dialogParams);
const info = computed(() => dialogParams.value?.info);

const title = computed(() =>
    $t("dialog.webhooks.delete_title", {
        messenger: "TikTok",
        number: info.value?.username,
    })
);

const onToggleLoadingButton = () => {
    button.value.loading = !button.value.loading;
    button.value.disabled = button.value.loading;
};

const deleteWebhooks = async () => {
    onToggleLoadingButton();

    try {
        await store.dispatch("tiktok/removeWebhooks", {
            userId: info.value.user_id,
            moshaToast: proxy.$moshaToast,
        });

        if (!!dialogParams.value?.next) {
            store.state.dialogParams.info.webhooks = [];
            store.commit("setDialog", dialogParams.value.next);
            store.commit("setNextDialog", "");
        } else {
            store.commit("closeDialog");
        }
    } catch (e) {
        // the toast is raised by the store action
    } finally {
        await store.dispatch("tiktok/loadAccounts", {
            visibility: info.value?.visibility,
        });
        onToggleLoadingButton();
    }
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
